import React from "react";
import { useState } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { BiSearch } from "react-icons/bi";
import { casinoTabs } from "../../lib/data/casinoTabs.data";
import { slotsData } from "../../lib/data/slots.data";
import SearchIcon from "../../assets/images/icons/search.png";
import { t } from "i18next";

const GamesSearchModal = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [filteredData, setFilteredData] = useState(null);
  const [searchText, setSearchText] = useState(false);
  const totalGames = {
    ...casinoTabs.lobby,

    ...slotsData.trending,
    ...slotsData.netent,
    ...slotsData.redtiger,
    ...slotsData.jili,
    ...slotsData.hacksaw,
    ...slotsData.turbo,
    ...slotsData.playNGo,
    ...slotsData.relaxGaming,
    ...slotsData.habanero,
    ...slotsData.gameart,
    ...slotsData.dragoonSoft,
  };
  const allGames = Object.values(totalGames);

  const handleSearch = (e) => {
    if (e) {
      setSearchText(true);

      let filteredValue = Object.values(totalGames)?.filter((item) => {
        return (
          item.name && item.name.toLowerCase().indexOf(e?.toLowerCase()) > -1
        );
      });
      setFilteredData(filteredValue);
    } else {
      setSearchText(false);
    }
  };

  return (
    <>
      <div className="searchGames" onClick={handleShow}>
        <img src={SearchIcon} alt="SearchICon" />
        <span>{t ("searchGames")}</span>
      </div>

      <Modal
        size="md"
        show={show}
        onHide={handleClose}
        className="searchGamesModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t ("searchYourFavouriteGames")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <InputGroup className="mb-3 search-icon">
            <Form.Control
              placeholder="Search"
              aria-label="Text input with dropdown button"
              type="search"
              onChange={(e) => handleSearch(e.target.value)}
              autoFocus
            />
          </InputGroup>
          <div className="GamesShow">
            {filteredData &&
              filteredData.map((item) => (
                <div className="displayGames">
                  <a href={item.redirectUrl}>
                    {item.imgUrl ? <img src={item.imgUrl} /> : item.img}
                    <span>{item.name}</span>
                  </a>
                </div>
              ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GamesSearchModal;
